import type { CSSProperties } from 'react';
import type { IBackLinkProps, IBackLinkState } from './BackLink.interface';
import styles from './BackLink.module.css';

export enum StyleElem {
    Container = 'Container',
    Div = 'Div',
    Icon = 'Icon',
    SVG = 'SVG',
}

const DEFAULT: Record<StyleElem, CSSProperties> = {
    [StyleElem.Container]: {},
    [StyleElem.Div]: {},
    [StyleElem.Icon]: {},
    [StyleElem.SVG]: {},
};

export function classNameForElement(element: StyleElem, model: IBackLinkProps): string {
    const name = element.toString();
    const classLoad = styles[name];
    return classLoad || '';
}

const PROPSSTATE_APPLICATOR: Record<
    StyleElem,
    (props: IBackLinkProps, state: IBackLinkState) => CSSProperties
> = {
    [StyleElem.Container]: (props: IBackLinkProps, state: IBackLinkState) => ({
        opacity: state.isHighlighted ?? false ? 0.7 : 1.0,
    }),
    [StyleElem.Div]: (props: IBackLinkProps, state: IBackLinkState) => ({
        backgroundColor: props.backgroundColor,
        borderColor: props.strokeColor,
        borderWidth: props.strokeSize,
    }),
    [StyleElem.Icon]: (props: IBackLinkProps, state: IBackLinkState) => ({}),
    [StyleElem.SVG]: (props: IBackLinkProps, state: IBackLinkState) => ({
        color: props.arrowColor ?? 'white',
    }),
};

export function styleForElement(
    element: StyleElem,
    props: IBackLinkProps,
    state: IBackLinkState,
    overrides: CSSProperties,
) {
    const style = {
        ...DEFAULT[element],
        ...PROPSSTATE_APPLICATOR[element](props, state),
        ...overrides,
    };

    return style;
}
